<template>
  <div class="pc-works-detail detail-page">
    <BreadCrumb :data="breadcrumb" :title="'作品详情管理'" />
    <El-button v-if="!isEditting" @click="edit()" class="edit-btn"
      >编辑</El-button
    >
    <div v-show="!isEditting" class="detail-form-information">
      <h2>基本信息</h2>
      <div class="form-content">
        <!-- 左边边图片 -->
        <div class="imgBox">
          <img
            v-if="worksDetail.cover_image"
            :src="worksDetail.cover_image"
            alt=""
            class="form-content-img"
          />
          <img
            v-else
            src="../../../../static/image/no-img.png"
            alt=""
            class="form-content-img no-img"
          />
        </div>
        <!-- 右边文字内容 -->
        <ul class="form-content-description">
          <li class="exclusive">
            <h4>wupen_id</h4>
            <span>{{ worksDetail.wupen_id }}</span>
          </li>
          <li class="half">
            <h4>中文名</h4>
            <span>{{ worksDetail.chinese_title }}</span>
          </li>
          <li class="half">
            <h4>英文名</h4>
            <span>{{ worksDetail.english_title }}</span>
          </li>
          <li class="half">
            <h4>国家</h4>
            <span>{{ worksDetail.country }}</span>
          </li>
          <li class="half">
            <h4>城市</h4>
            <span>{{ worksDetail.city }}</span>
          </li>
          <li class="exclusive">
            <h4>经纬度</h4>
            <span v-if="worksDetail.lng && worksDetail.lat"
              >lng {{ worksDetail.lng }} lat {{ worksDetail.lat }}</span
            >
            <span v-else>暂无</span>
          </li>
          <li class="exclusive">
            <h4>设计师</h4>
            <span
              v-for="(item, index) in worksDetail.works_related_data.designers"
              :key="index"
              >{{ item.chinese_name }} ;</span
            >
          </li>
          <li class="exclusive">
            <h4>作品分类</h4>
            <span
              v-for="(item, index) in worksDetail.works_related_data
                .classifications"
              :key="index"
              >{{ item.chinese_name }} ;</span
            >
          </li>
          <li class="exclusive">
            <h4>作品竞赛分类</h4>
            <span>{{
              worksDetail.competition
                ? worksDetail.competition.chinese_name
                : ""
            }}</span>
          </li>
          <li class="exclusive">
            <h4>基地</h4>
            <span>{{
              worksDetail.base ? worksDetail.base.chinese_name : ""
            }}</span>
          </li>
          <li class="exclusive">
            <h4>展览</h4>
            <span
              v-for="(item, index) in worksDetail.works_related_data
                .exhibitions"
              :key="index"
              >{{ item.chinese_name }} ;</span
            >
          </li>
          <li class="exclusive">
            <h4>指导人</h4>
            <span
              v-for="(item, index) in worksDetail.works_related_data.guiders"
              :key="index"
              >{{ item.chinese_name }} ;</span
            >
          </li>

          <li class="exclusive">
            <h4>提供方</h4>
            <span
              v-for="(item, index) in worksDetail.works_related_data
                .organizations"
              :key="index"
              >{{ item.chinese_name }} ;</span
            >
          </li>
          <li class="one-third">
            <h4>版式</h4>

            {{worksDetail.set_type == 0 ? "横版" : "竖版"}}
          </li>
          <li class="one-third">
            <h4>状态</h4>
            <el-switch
              v-model="worksDetail.status"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              disabled
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
        </ul>
      </div>
    </div>
    <div v-show="isEditting" class="detail-form-information">
      <h2>基本信息</h2>
      <div class="form-content">
        <!-- 左边边图片 -->
        <div class="imgbox">
          <UploadImage
            :img="worksDetail.cover_image"
            :width="230"
            :height="160"
            @getUploadImage="getUploadCoverImage"
          ></UploadImage>
        </div>

        <!-- 右边文字内容 -->
        <ul class="form-content-description">
          <li class="exclusive">
            <h4>wupen_id</h4>
            <span>{{ worksDetail.wupen_id }}</span>
          </li>
          <li class="exclusive">
            <h4>中文名<span>*</span></h4>
            <el-input
              v-model="worksDetail.chinese_title"
              placeholder="请输入中文标题"
            ></el-input>
          </li>
          <li class="exclusive">
            <h4>英文名<span>*</span></h4>
            <el-input
              v-model="worksDetail.english_title"
              placeholder="请输入英文标题"
            ></el-input>
          </li>
          <li class="half">
            <h4>国家</h4>
            <el-input
              v-model="worksDetail.country"
              placeholder="请输入国家"
            ></el-input>
          </li>
          <li class="half">
            <h4>城市</h4>
            <el-input
              v-model="worksDetail.city"
              placeholder="请输入城市"
            ></el-input>
          </li>
          <li class="half">
            <h4>经度<span>*</span></h4>
                    <el-input-number
          v-model.number="worksDetail.lng"
          @input.native="onInput"
        ></el-input-number>
          </li>
          <li class="half">
            <h4>纬度<span>*</span></h4>
                                <el-input-number
          v-model.number="worksDetail.lat"
          @input.native="onInput"
          placeholder=""
        ></el-input-number>
          </li>

          <li class="half">
            <h4>提供方</h4>
            <el-select
              v-model="worksDetail.works_related_data.organizations"
              multiple
              filterable
              placeholder="请选择"
              value-key="id"
            >
              <el-option
                v-for="item in organizationList"
                :key="item.label"
                :label="item.chinese_name"
                :value="item"
              ></el-option>
            </el-select>
          </li>

          <li class="half">
            <h4>展览</h4>
            <el-select
              v-model="worksDetail.works_related_data.exhibitions"
              multiple
              filterable
              placeholder="请选择"
              value-key="id"
            >
              <el-option
                v-for="item in exhibitionList"
                :key="item.label"
                :label="item.chinese_name"
                :value="item"
              ></el-option>
            </el-select>
          </li>

          <li class="half">
            <h4>设计师</h4>
            <el-select
              v-model="worksDetail.works_related_data.designers"
              multiple
              filterable
              placeholder="请选择"
              value-key="id"
            >
              <el-option
                v-for="item in designerList"
                :key="item.label"
                :label="item.chinese_name"
                :value="item"
              ></el-option>
            </el-select>
          </li>

          <li class="half">
            <h4>作品分类</h4>
            <el-select
              v-model="worksDetail.works_related_data.classifications"
              multiple
              filterable
              placeholder="请选择"
              value-key="id"
            >
              <el-option
                v-for="item in classificationList"
                :key="item.label"
                :label="item.chinese_name"
                :value="item"
              ></el-option>
            </el-select>
          </li>

          <li class="half">
            <h4>作品竞赛分类</h4>
            <el-select
              v-model="worksDetail.competition"
              filterable
              clearable
              placeholder="请选择"
              value-key="id"
            >
              <el-option
                v-for="item in competitionList"
                :key="item.label"
                :label="item.chinese_name"
                :value="item"
              ></el-option>
            </el-select>
          </li>

          <li class="half">
            <h4>指导人</h4>
            <el-select
              v-model="worksDetail.works_related_data.guiders"
              multiple
              filterable
              placeholder="请选择"
              value-key="id"
            >
              <el-option
                v-for="item in guiderList"
                :key="item.label"
                :label="item.chinese_name"
                :value="item"
              ></el-option>
            </el-select>
          </li>

          <li class="half">
            <h4>基地</h4>
            <el-select
              v-model="worksDetail.base"
              filterable
              clearable
              placeholder="请选择"
              value-key="id"
            >
              <el-option
                v-for="item in baseList"
                :key="item.label"
                :label="item.chinese_name"
                :value="item"
              ></el-option>
            </el-select>
          </li>
                    <li class="half">
            <h4>版式</h4>
                  <el-select
          v-model="worksDetail.set_type"
          clearable
          placeholder="版式"
        >
          <el-option label="横版" :value="0"></el-option>
          <el-option label="竖版" :value="1"></el-option>
        </el-select>
        </li>

          <!-- <li class="one-third">
            <h4>类型</h4>
            <el-switch
              v-model="worksDetail.set_type"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li> -->

          <li class="one-third">
            <h4>状态</h4>
            <el-switch
              v-model="worksDetail.status"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
        </ul>
      </div>
    </div>

    <div class="pc-dataDetail-tags">
      <h2>作品标签</h2>
      <div class="input" v-if="isEditting">
        <keywordsinput :maxLen="18" v-model="worksDetail.tags"></keywordsinput>
      </div>
      <div v-else class="show">
        <p v-for="(tag, index) in worksDetail.tags" :key="index">
          {{ tag }}
        </p>
      </div>
    </div>

    <div class="pc-dataDetail-intro">
      <h2>作品介绍</h2>

      <div class="content">
        <h4>中文简介</h4>
        <el-input
          type="textarea"
          v-if="isEditting"
          :rows="15"
          placeholder="请输入内容"
          v-model="worksDetail.chinese_introduce"
        >
        </el-input>
        <p v-else class="worksDetailIntro">
          {{
            worksDetail.chinese_introduce
              ? worksDetail.chinese_introduce
              : "暂无"
          }}
        </p>
      </div>
      <TranslateText
        class="translate-btn"
        v-if="isEditting"
        :chinese="worksDetail.chinese_introduce"
        :english="worksDetail.english_introduce"
        @returnTranslate="returnTranslate"
      />
      <div class="content">
        <h4>英文简介</h4>
        <el-input
          v-if="isEditting"
          type="textarea"
          :rows="15"
          placeholder="请输入内容"
          v-model="worksDetail.english_introduce"
        >
        </el-input>
        <p v-else class="worksDetailIntro">
          {{
            worksDetail.english_introduce
              ? worksDetail.english_introduce
              : "暂无"
          }}
        </p>
      </div>
    </div>
    <EditContent
      ref="worksContent"
      :header="'作品'"
      :content="worksDetail.detail"
      :isEditting="isEditting"
    ></EditContent>
    <div class="works-images">
      <h2>图片</h2>

      <div class="images-box">
        <UploadImage
          v-if="isEditting"
          :width="230"
          :height="120"
          @getUploadImage="getUploadImage"
          class="form-content-img upload-image"
        ></UploadImage>

        <div class="image-list">
          <div
            class="image-item"
            v-for="(item, index) in worksDetail.images"
            :key="index"
          >
            <img :src="item" />
            <i
              v-show="isEditting"
              @click="removeImgae(index)"
              class="el-icon-error iconPosi"
            ></i>
          </div>
        </div>
      </div>
    </div>

    <div class="works-images">
      <h2>作品图片</h2>

      <div class="images-box">
        <UploadImage
          v-if="isEditting"
          :width="230"
          :height="120"
          @getUploadImage="getUploadWorksImage"
          class="form-content-img upload-image"
        ></UploadImage>

        <div class="image-list">
          <div
            class="image-item"
            v-for="(item, index) in worksDetail.works_images"
            :key="index"
          >
            <img :src="item" />
            <i
              v-show="isEditting"
              @click="removeImgae1(index)"
              class="el-icon-error iconPosi"
            ></i>
          </div>
        </div>
      </div>
    </div>

    <div class="pc-works-books" v-show="!isEditting">
      <div class="pc-works-textbook">
        <h2>作品文件</h2>
        <a class="el-icon-document" :href="worksDetail.docs">{{
          worksDetail.docs ? worksDetail.docs : "暂无"
        }}</a>
      </div>
      <div class="pc-works-handouts">
        <h2>作品模型文件</h2>
        <a class="el-icon-document" :href="worksDetail.model">{{
          worksDetail.model ? worksDetail.model : "暂无"
        }}</a>
      </div>
    </div>

    <div class="pc-works-books" v-show="isEditting">
      <!-- 作品文件 -->
      <div class="pc-works-textbook">
        <h2>作品文件</h2>
        <UploadFile
          :file="worksDetail.docs"
          @getUploadFile="getUploadDocs"
          :title="'作品'"
        ></UploadFile>
      </div>
      <!-- 作品模型文件 -->
      <div class="pc-works-handouts">
        <h2>作品模型文件</h2>
        <UploadFile
          :file="worksDetail.model"
          @getUploadFile="getUploadModel"
          :title="'作品模型'"
        ></UploadFile>
      </div>
    </div>

    <div class="pc-works-books" v-if="$route.query.method == 'update'">
      <div class="pc-works-video">
        <h2>作品视频文件</h2>
        <video controls :src="worksDetail.video"></video>
        <UploadVideo
          :file="worksDetail.video"
          @getUploadVideo="getUploadVideo"
          :title="'作品视频'"
        ></UploadVideo>
      </div>
      <!-- <div class="pc-works-audio">
        <h2>作品音频文件</h2>
        <UploadVideo
          :file="worksDetail.audio"
          @getUploadFile="getUploadAudio"
          :title="'作品音频'"
        ></UploadVideo>
      </div> -->
    </div>
    <SaveGroup
      :isEditting="isEditting"
      @cancelUpdate="cancelUpdate"
      @save="save"
      @recover="recover"
      @view="view"
      @cancelAdd="cancelAdd"
      @add="add"
    />
  </div>
</template>
<script>
import BreadCrumb from "@/components/componentSet/BreadCrumb";
import UploadImage from "../../componentSet/uploadImage.vue";
import SaveGroup from "../../componentSet/SaveGroup.vue";
import EditContent from "../../componentSet/EditContent.vue";
import TranslateText from "../../componentSet/TranslateText.vue";
import {
  getWorksDetail_Api,
  setWorksDetail_Api,
  updateWorksDetail_Api,
  organizationDropDown_Api,
  exhibitionDropDown_Api,
  designerDropDown_Api,
  baseDropDown_Api,
  worksClassification_Api,
  exhibitionCompetitionDropDown_Api,
} from "@/apis/exhibition.api";
import TagDetail from "@/components/template/TagDetail";
import UploadFile from "../../componentSet/uploadFile.vue";
import UploadVideo from "./component/UploadVideo.vue";
export default {
  components: {
    UploadImage,
    BreadCrumb,
    SaveGroup,
    TagDetail,
    UploadFile,
    UploadVideo,
    EditContent,
    TranslateText,
  },
  computed: {
    breadcrumb: function () {
      return [
        {
          name: "首页",
          link: "/admin/main",
        },
        { name: "作品列表", link: "/admin/worksList" },
        {
          name: `${
            (
              this.worksDetail.chinese_title
                ? this.worksDetail.chinese_title
                : this.worksDetail.english_title
            )
              ? this.worksDetail.chinese_title
                ? this.worksDetail.chinese_title
                : this.worksDetail.english_title
              : ""
          }`,
          link: "/admin/worksDetail",
        },
      ];
    },
  },
  data() {
    return {
      isEditting: true,
      worksDetail: {
        id: null,
        chinese_introduce: "",
        english_introduce: "",
        tickets_image: "",
        cover_image: "",
        organization_list: [],
        exhibition_list: [],
        designer_list: [],
        guider_list: [],
        classification_list: [],
        competition: [],
        competition_id: null,
        base_id: null,
        works_related_data: {},
        images_list: [],
        competition: { chinese_name: "" },
        base: { chinese_name: "" },

      },
      organizationList: [],
      exhibitionList: [],
      designerList: [],
      guiderList: [],
      baseList: [],
      competitionList: [],
      classificationList: [], 
    };
  },
  mounted() {
    if (this.$route.query.method == "update") {
      this.worksDetail.id = this.$route.query.id;
      this.getWorksDetail();
    }
    organizationDropDown_Api().then((res) => {
      this.organizationList = res.data;
      console.log(res.data);
    });
    exhibitionDropDown_Api().then((res) => {
      this.exhibitionList = res.data;
      console.log(res.data);
    });
    designerDropDown_Api().then((res) => {
      this.designerList = res.data;
      this.guiderList = res.data;
      console.log(res.data);
    });
    worksClassification_Api().then((res) => {
      this.classificationList = res.data;
      console.log(res.data);
    });
    baseDropDown_Api().then((res) => {
      this.baseList = res.data;
      console.log(res.data);
    });
    exhibitionCompetitionDropDown_Api().then((res) => {
      this.competitionList = res.data;
      console.log(res.data);
    });
  },

  methods: {
   onInput(e) {
       e.target.value=e.target.value.replace(/[^\d.]/g,'');
    },
    returnTranslate(data, flag) {
      flag == 1
        ? (this.worksDetail.english_introduce = data)
        : (this.worksDetail.chinese_introduce = data);
      console.log(data);
      console.log(flag);
    },
    getWorksDetail(hint) {
      getWorksDetail_Api(this.worksDetail.id).then((res) => {
        hint ? this.$global.success(this, hint) : "";
        this.worksDetail = res.data;
        if(this.worksDetail.lng == ""){
          this.worksDetail.lng = undefined
        }
                if(this.worksDetail.lat == ""){
          this.worksDetail.lat = undefined
        }
        console.log(this.worksDetail);
      });
    },
    getUploadCoverImage(img_url) {
      this.worksDetail.cover_image = img_url;
    },
    getUploadTicketsImage(img_url) {
      this.worksDetail.tickets_image = img_url;
    },
    getUploadDocs(file_url) {
      this.worksDetail.docs = file_url;
    },
    getUploadModel(file_url) {
      this.worksDetail.model = file_url;
    },
    getUploadVideo(file_url) {
      this.worksDetail.video = file_url;
    },
    getUploadImage(img_url) {
      this.worksDetail.images.unshift(img_url);
      console.log(this.worksDetail.images);
    },
    getUploadWorksImage(img_url) {
      this.worksDetail.works_images.unshift(img_url);
      console.log(this.worksDetail.works_images);
    },
    removeImgae(index) {
      this.worksDetail.images.splice(index, 1);
    },
    removeImgae1(index) {
      this.worksDetail.works_images.splice(index, 1);
    },
    // save group 回调函数
    cancelUpdate() {
      this.getWorksDetail("取消成功");
      this.isEditting = false;
    },
    recover() {
      this.getWorksDetail("恢复成功");
    },
    view() {
      window.open("http://wupen.org/exhibition/work/" + this.$route.query.id, "_blank");
    },
    cancelAdd() {
      window.close();
    },
    add() {
      let formattedData = this.validateForm(this.worksDetail);
      if (!formattedData) {
        return;
      } else {
        setWorksDetail_Api(formattedData)
          .then((res) => {
            this.isEditting = false;
            this.worksDetail.id = res.data.id;
            this.getWorksDetail();
            this.$router.push({
              path: "/admin/worksDetail",
              query: { id: res.data.id, method: "update" },
            });
            this.$global.success(this, "创建成功！", null);
          })
          .catch((err) => {
            this.$global.error(this, "创建失败！", null);
          });
      }
    },
    save() {
      let formattedData = this.validateForm(this.worksDetail);
      if (!formattedData) {
        return;
      } else {
        updateWorksDetail_Api(formattedData)
          .then((res) => {
            if (res.code === 205) {
              this.$global.success(this, "更新成功");
              this.getWorksDetail();
              this.isEditting = false;
            } else {
              this.$global.error(this, "更新失败！", null);
            }
          })
          .catch(() => {
            this.$global.error(this, "更新失败！", null);
          });
      }
    },
    // 点击编辑
    edit() {
      this.isEditting = true;
    },

    validateForm(formData) {
      //表单校验
      if (!formData.chinese_title || !formData.english_title) {
        this.$global.error(this, "请输入中英文标题");
        return false;
      }
      if (!formData.lng || !formData.lat) {
        this.$global.error(this, "请输入经纬度");
        return false;
      }
      if (formData.works_related_data.organizations) {
        formData.organization_list =
          formData.works_related_data.organizations.map((item) => {
            return item.id;
          });
      }
      if (formData.works_related_data.designers) {
        formData.designer_list = formData.works_related_data.designers.map(
          (item) => {
            return item.id;
          }
        );
      }
      if (formData.works_related_data.exhibitions) {
        formData.exhibition_list = formData.works_related_data.exhibitions.map(
          (item) => {
            return item.id;
          }
        );
      }
      if (formData.works_related_data.guiders) {
        formData.guider_list = formData.works_related_data.guiders.map(
          (item) => {
            return item.id;
          }
        );
      }
      if (formData.works_related_data.classifications) {
        formData.classification_list =
          formData.works_related_data.classifications.map((item) => {
            return item.id;
          });
      }
      if (formData.competition) {
        formData.competition_id = formData.competition.id;
      } else {
        formData.competition_id = 0;
      }
      if (formData.base) {
        formData.base_id = formData.base.id;
      } else {
        formData.base_id = 0;
      }
      formData.detail = this.$refs.worksContent.getContent();
      formData.keywords = formData.tags;
      formData.images_list = formData.images;
      formData.works_images_list = formData.works_images;
      formData.works_id = formData.id;
      console.log(formData);
      return formData;
    },
  },
};
</script>
<style lang="scss" scoped>
.pc-works-detail {
  .imgBox {
    display: flex;
    flex-direction: column;
    width: 30%;
    height: 30%;
  }
  .worksDetailIntro {
    word-break: break-all;
    text-indent: 2em;
  }
  .imgBox .form-content-img {
    width: 230px;
    height: 160px;
  }
  .imgBox .form-content-img1 {
    width: 230px;
    height: 120px;
  }
  .no-img {
    width: 200px !important;
    height: 150px !important;
  }
  .pc-works-books {
    display: flex;
    width: 100%;
    justify-content: space-between;
    /deep/ button.el-button.el-button--primary.el-button--small {
      padding: 0;
      background: #fff;
      color: #000;
      border: none;
    }
    /deep/ .el-icon-document:before {
      margin-right: 10px;
      word-wrap: break-word;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 8;
      overflow: hidden;
    }
    .pc-works-textbook {
      @include box-model;
      width: 48%;
      margin-right: 40px;
    }
    .pc-works-handouts {
      @include box-model;
      width: 48%;
    }
    .pc-works-video {
      @include box-model;
      width: 48%;
      video {
        width: 60%;
      }
    }
    .pc-works-audio {
      @include box-model;
      width: 48%;
    }
  }
  /deep/ .el-select {
    width: 100%;
  }
  .works-images {
    @include box-model;
    .images-box {
      overflow-y: hidden;
      overflow-x: auto;
      display: flex;
      height: 170px;
      .upload-image {
        margin-right: 20px;
      }
      .image-list {
        display: flex;
        .image-item {
          position: relative;
          display: inline-block;
          margin-right: 20px;
          img {
            height: 140px;
          }
          .el-icon-error {
            color: $base-color;
            cursor: pointer;
            position: absolute;
            top: 10px;
            right: 10px;
          }
        }
        .image-item:last-child {
          margin-right: 0px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/exhibition/WorksDetail.vue